module.exports = __webpack_public_path__ + "img/text-right-image-left.10f8bee2.svg";